import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/siteData";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20romantic%20and%20dreamy%20scene%20with%20soft%20pink%20and%20peach%20toned%20abstract%20gradient%20background%2C%20floating%20heart%20shapes%20and%20sparkling%20particles%2C%20warm%20atmospheric%20lighting%2C%20love%20and%20romance%20concept%2C%20modern%20minimalist%20design%2C%20clean%20and%20elegant%20aesthetic%2C%20soft%20bokeh%20effects%2C%20ethereal%20atmosphere&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="爱情岛论坛"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/15 backdrop-blur-sm rounded-full border border-background-50/20 mb-6">
          <i className="ri-sparkling-line text-background-50 text-sm"></i>
          <span className="text-sm text-background-50/90 whitespace-nowrap">高清免费视频在线观看平台</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-5 leading-tight">
          爱情岛论坛
          <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-2 text-background-50/80">
            在线观看 · 高清视频入口
          </span>
        </h1>

        <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚爱情岛论坛在线观看最新资源，提供免费高清视频播放，无需下载，随时随地流畅观看。支持多线路切换，让您享受极致观看体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/dating-tips"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>立即观看
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-lg text-sm font-medium hover:bg-background-50/25 transition-all border border-background-50/20 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2"></i>了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-6 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">500万+</div>
            <div className="text-xs text-background-50/60 mt-1">累计用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">3000+</div>
            <div className="text-xs text-background-50/60 mt-1">视频内容</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">100万+</div>
            <div className="text-xs text-background-50/60 mt-1">日均播放</div>
          </div>
        </div>
      </div>
    </section>
  );
}